module.exports = new __parcel__URL__("native-issue-table-skeleton-new.tpl.2bc4520f.svg").toString();